import { DealerHolidayBusinessService } from './../../business-services/dealer-holiday.service';
import { Observable } from 'rxjs';
import { UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EditDealerHolidayGuard  {

    constructor(
        private dealerHolidayBusinessService: DealerHolidayBusinessService,
        private router: Router
    ) {}

    canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if( this.dealerHolidayBusinessService.dealerHolidayId != 0 ) return true;
        return this.router.createUrlTree(['/dealer-holiday']);
    }
}